// Common translations used across all components
// These are shared translations that don't belong to a specific feature

export const commonTranslations = {
  fr: {
    'common.language': 'Langue',
    'common.languageDockCycle': 'Toucher pour changer (FR · EN · 中文)',
    'common.languageDockSelect': 'Choisir la langue',
    'common.guest': 'Invité',
    'common.client': 'Client',
    'common.manager': 'Gestionnaire',
    'common.staff': 'Employé',
    'common.sidebarDemo': 'Démonstration',
    'common.reception': 'Réception',
    'common.staffTasks': 'Mes tâches',
    'common.promoCodes': 'Codes promo',
    'common.loyaltyProgram': 'Programme de fidélité',
    'common.languageName.fr': 'Français',
    'common.languageName.en': 'English',
    'common.languageName.zh': '中文',
    'common.login': 'Connexion',
    'common.logout': 'Déconnexion',
    'common.backToBookingSite': 'Retour au site — réserver',
    'common.home': 'Accueil',
    'common.accommodations': 'Hébergements',
    'common.stays': 'Hébergements',
    'common.activities': 'Activités',
    'common.packages': 'Forfaits',
    'common.reservations': 'Réservations',
    'common.dashboard': 'Tableau de bord',
    'common.reports': 'Rapports',
    'common.crm': 'Gestion des clients',
    'common.marketing': 'Marketing',
    'common.settings': 'Paramètres',
    'common.scrollUp': 'Haut de page / section',
    'common.scrollDown': 'Bas de page / section',
    'common.calendarAssistantToggle': 'Ouvrir ou fermer l’assistant',
    'common.cartToggle': 'Ouvrir ou fermer le panier',
    'common.search': 'Rechercher',
    'common.filter': 'Filtrer',
    'common.available': 'Disponible',
    'common.unavailable': 'Indisponible',
    'common.price': 'Prix',
    'common.notEditable': 'n\'est pas modifiable.',
    'common.perNight': 'par nuit',
    'common.perPerson': 'par personne',
    'common.perNightPerPerson': 'par nuit par personne',
    'common.priceTaxIncludedShort': 'taxes incluses',
    'common.maxPersons': 'Maximum {count} personnes',
    'common.equipmentIncluded': 'Équipement inclus',
    'common.persons': 'personnes',
    'common.upTo': "Jusqu'à",
    'common.lakefront': 'Bord du lac',
    'common.popular': 'Populaire',
    'common.capacity': 'Capacité',
    'common.duration': 'Durée',
    'common.equipment': 'Équipement',
    'common.amenities': 'Équipements',
    'common.location': 'Emplacement',
    'common.type': 'Type',
    'common.description': 'Description',
    'common.book': 'Réserver',
    'common.planYourVisit': 'Planifiez votre visite',
    'common.quickBook': 'Réservation rapide',
    'common.addToCart': 'Ajouter au panier',
    'common.cart': 'Panier',
    'common.accountDockSignedInHint': 'Portail ou déconnexion',
    'common.quickNavigation': 'Navigation rapide',
    'common.dockClickHint':
      'Astuce : touchez ou cliquez une icône pour ouvrir ou fermer (calendrier, panier, etc.). Survolez pour voir le détail.',
    'common.inCart': 'Dans le panier',
    'common.clear': 'Effacer',
    'common.clearFilters': 'Effacer les filtres',
    'common.removeFromCart': 'Retirer du panier',
    'common.like': 'J\'aime',
    'common.unlike': 'Je n\'aime plus',
    'common.addToFavorites': 'Ajouter aux favoris',
    'common.removeFromFavorites': 'Retirer des favoris',
    'common.share': 'Partager',
    'common.linkCopied': 'Lien copié!',
    'common.actions': 'Actions',
    'common.viewDetails': 'Voir détails',
    'common.back': 'Retour aux hébergements',
    'common.goBack': 'Retour',
    'common.backToHome': 'Retour à l\'accueil',
    'common.priceStartsAt': 'Prix à partir de :',
    'common.bookNow': 'RÉSERVER MAINTENANT',
    'common.status': 'Statut',
    'common.edit': 'Modifier',
    'common.delete': 'Supprimer',
    'common.remove': 'Retirer',
    'common.name': 'Nom',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.add': 'Ajouter',
    'navigation.home': 'Accueil',
    'navigation.stays': 'Séjours',
    'navigation.activities': 'Activités',
    'navigation.forfaits': 'Forfaits',
    'navigation.gallery': 'Galerie',
    'stays.backToList': 'Retour aux séjours',
    'common.lac': 'Lac',
    'common.forêt': 'Forêt',
    'common.mixte': 'Mixte',
    'common.photo': 'Photo',
    'stays.availability': 'Disponibilité',
    'stays.backToList': 'Retour aux séjours',
    'stays.aboutRoom': 'Détails de notre chambre',
    'stays.whatsIncluded': 'Ce qui est inclus dans ce forfait',
    'stays.roomAmenities': 'Équipements de la chambre',
    'stays.relatedStays': 'Découvrez des séjours similaires',
    'activities.backToList': 'Retour aux activités',
    'activities.aboutActivity': 'À propos de cette activité',
    'activities.whatsIncluded': 'Ce qui est inclus',
    'activities.included': 'Inclus',
    'activities.notIncluded': 'Non inclus',
    'activities.optionalPaid': 'Optionnel (payant)',
    'activities.quickFacts': 'En bref',
    'activities.relatedActivities': 'Autres activités',
    'activities.singleDescription': 'Sélectionnez une date pour réserver cette activité.',
    'forfaits.backToList': 'Retour aux forfaits',
    'common.favorite': 'Favori',
    'common.zone': 'Zone',
    'amenities.wifi': 'Wi-Fi gratuit',
    'amenities.tv': 'Télévision intelligente',
    'amenities.coffee': 'Cafetière',
    'amenities.bath': 'Salle de bain privée',
    'amenities.capacity': 'Capacité',
    'amenities.location': 'Excellent emplacement',
    'common.optional': 'Optionnel',
    'common.confirm': 'Confirmer',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.configure': 'Configurer',
    'common.preview': 'Aperçu',
    'common.total': 'Total',
    'common.subtotal': 'Sous-total',
    'common.tax': 'Taxes',
    'common.gst': 'TPS',
    'common.qst': 'TVQ',
    'common.taxGstLabel': 'TPS / GST (5 %)',
    'common.taxQstLabel': 'TVQ / QST (9,975 %)',
    'common.taxLodgingLabel': 'Taxe d\'hébergement (3,50 $ / nuit)',
    'common.checkoutSalesTaxNote':
      'TPS et TVQ : chacune sur le montant imposable (sous-total + taxe d\'hébergement le cas échéant) ; la TVQ ne s\'applique pas sur la TPS.',
    'common.grandTotal': 'Total général',
    'common.checkout': 'Commander',
    'common.checkoutAsGuest': 'Commander en tant qu\'invité',
    'common.checkoutAsMember': 'Commander en tant que membre',
    'common.selectedItems': 'Articles sélectionnés',
    'common.orderSummary': 'Résumé de la commande',
    'common.completeOrder': 'Finaliser la commande',
    'common.payAsGuest': 'Payer en tant qu\'invité',
    'common.payAsMember': 'Payer en tant que membre',
    'common.choosePaymentMethod': 'Choisir le mode de paiement',
    'common.selectAll': 'Tout sélectionner',
    'common.deselectAll': 'Tout désélectionner',
    'common.select': 'Sélectionner',
    'common.deselect': 'Désélectionner',
    'common.selected': 'sélectionné(s)',
    'common.item': 'article',
    'common.items': 'articles',
    'common.quantity': 'Quantité',
    'common.booking': 'Réservation',
    'common.bookingDetails': 'Détails de réservation',
    'common.checkIn': 'Arrivée',
    'common.checkOut': 'Départ',
    'common.guests': 'Invités',
    'common.adults': 'Adultes',
    'common.children': 'Enfants',
    'common.notes': 'Notes',
    'common.specialRequests': 'Demandes spéciales',
    'common.contactInfo': 'Informations de contact',
    'common.email': 'Courriel',
    'common.phone': 'Téléphone',
    'common.hello': 'Bonjour',
    'common.clientPortal': 'Espace client',
    'common.myAccount': 'Mon compte',
    'common.address': 'Adresse',
    'common.city': 'Ville',
    'common.province': 'Province',
    'common.postalCode': 'Code postal',
    'common.country': 'Pays',
    'common.paymentMethod': 'Méthode de paiement',
    'paymentLink.title': 'Payer votre réservation',
    'paymentLink.greeting': 'Bonjour {name},',
    'paymentLink.accommodation': 'Hébergement',
    'paymentLink.checkIn': 'Arrivée',
    'paymentLink.checkOut': 'Départ',
    'paymentLink.total': 'Total à payer',
    'paymentLink.invalid': 'Lien de paiement invalide.',
    'paymentLink.unavailableTitle': 'Lien indisponible',
    'paymentLink.unavailableBody': 'Ce lien a expiré, a déjà été utilisé ou n\'existe plus.',
    'paymentLink.successTitle': 'Paiement reçu',
    'paymentLink.successBody': 'Merci — votre réservation est confirmée. Vous recevrez un courriel de confirmation.',
    'common.creditCard': 'Carte de crédit',
    'common.cardNumber': 'Numéro de carte',
    'common.expiryDate': 'Date d\'expiration',
    'common.cvv': 'CVV',
    'common.cardholderName': 'Nom du titulaire',
    'common.billingAddress': 'Adresse de facturation',
    'common.sameAsContact': 'Identique à l\'adresse de contact',
    'common.termsAndConditions': 'Termes et conditions',
    'common.privacyPolicy': 'Politique de confidentialité',
    'common.refundPolicy': 'Politique de remboursement',
    'common.bookingPolicy': 'Politique de réservation',
    'common.cancellationPolicy': 'Politique d\'annulation',
    'common.weather': 'Météo',
    'common.sunny': 'Ensoleillé',
    'common.cloudy': 'Nuageux',
    'common.rainy': 'Pluvieux',
    'common.snowy': 'Neigeux',
    'common.mph': 'mi/h',
    'common.menu': 'Menu',
    'common.close': 'Fermer',
    'common.question': 'Question',
    'common.sendMessage': 'Envoyer le message',
    'common.allRightsReserved': 'Tous droits réservés.',
    'common.temperature': 'Température',
    'common.conditions': 'Conditions',
    'common.forecast': 'Prévisions',
    'common.today': 'Aujourd\'hui',
    'common.tomorrow': 'Demain',
    'common.thisWeek': 'Cette semaine',
    'common.previous': 'Précédent',
    'common.next': 'Suivant',
    'common.nextWeek': 'Semaine prochaine',
    'common.thisMonth': 'Ce mois',
    'common.nextMonth': 'Mois prochain',
    'common.thisYear': 'Cette année',
    'common.nextYear': 'Année prochaine',
    'common.january': 'Janvier',
    'common.february': 'Février',
    'common.march': 'Mars',
    'common.april': 'Avril',
    'common.may': 'Mai',
    'common.june': 'Juin',
    'common.july': 'Juillet',
    'common.august': 'Août',
    'common.september': 'Septembre',
    'common.october': 'Octobre',
    'common.november': 'Novembre',
    'common.december': 'Décembre',
    'common.monday': 'Lundi',
    'common.tuesday': 'Mardi',
    'common.wednesday': 'Mercredi',
    'common.thursday': 'Jeudi',
    'common.friday': 'Vendredi',
    'common.saturday': 'Samedi',
    'common.sunday': 'Dimanche',
    'common.morning': 'Matin',
    'common.afternoon': 'Après-midi',
    'common.evening': 'Soir',
    'common.night': 'Nuit',
    'common.weekend': 'Fin de semaine',
    'common.weekday': 'Jour de semaine',
    'common.holiday': 'Jour férié',
    'common.season': 'Saison',
    'common.spring': 'Printemps',
    'common.summer': 'Été',
    'common.autumn': 'Automne',
    'common.winter': 'Hiver',
    'common.allSeasons': 'Toute l\'année',
    'common.catalogUpdatingTitle': 'Section en mise à jour',
    'common.catalogUpdatingBody':
      'Nous enrichissons notre offre — cette liste sera bientôt complétée. Merci de votre patience.',
    'common.lake': 'Bord du lac',
    'common.forest': 'En forêt',
    'common.mixed': 'Mixte',
    'common.cabin': 'Chalet',
    'common.yurt': 'Yourte',
    'common.unit': 'Unité',
    'common.fishing': 'Pêche',
    'common.hunting': 'Chasse',
    'common.kayaking': 'Kayak',
    'common.hiking': 'Randonnée',
    'common.snowshoeing': 'Raquettes',
    'common.skiing': 'Ski',
    'common.snowmobiling': 'Motoneige',
    'common.iceFishing': 'Pêche sur glace',
    'common.wildlife': 'Faune',
    'common.birdWatching': 'Observation d\'oiseaux',
    'common.photography': 'Photographie',
    'common.nature': 'Nature',
    'common.adventure': 'Aventure',
    'common.relaxation': 'Détente',
    'common.family': 'Famille',
    'common.couples': 'Couples',
    'common.groups': 'Groupes',
    'common.solo': 'Solo',
    'common.business': 'Affaires',
    'common.leisure': 'Loisirs',
    'common.luxury': 'Luxe',
    'common.budget': 'Économique',
    'common.midRange': 'Moyen',
    'common.premium': 'Premium',
    'common.basic': 'Basique',
    'common.standard': 'Standard',
    'common.deluxe': 'Deluxe',
    'common.suite': 'Suite',
    'common.studio': 'Studio',
    'common.oneBedroom': 'Une chambre',
    'common.twoBedroom': 'Deux chambres',
    'common.threeBedroom': 'Trois chambres',
    'common.fourBedroom': 'Quatre chambres',
    'common.penthouse': 'Penthouse',
    'common.villa': 'Villa',
    'common.chalet': 'Chalet',
    'common.cottage': 'Cottage',
    'common.lodge': 'Lodge',
    'common.resort': 'Résort',
    'common.hotel': 'Hôtel',
    'common.motel': 'Motel',
    'common.hostel': 'Auberge',
    'common.bedAndBreakfast': 'Gîte',
    'common.airbnb': 'Airbnb',
    'common.vrbo': 'VRBO',
    'common.expedia': 'Expedia',
    'common.tripadvisor': 'TripAdvisor',
    'common.calendar': 'Calendrier',
    'common.serviceType': 'Type de service',
    'common.all': 'Tous',
    'common.selectService': 'Sélectionner un service',
    'common.hide': 'Masquer',
    'common.show': 'Afficher',
    'common.list': 'Liste',
    'common.tickets': 'Billets',
    'common.grid': 'Grille',
    'common.monthly': 'Mensuel',
    'common.weekly': 'Hebdomadaire',
    'common.legend': 'Légende',
    'common.availableOn': 'Disponible le',
    'common.viewCalendar': 'Voir calendrier',
    'common.hours': 'heures',
    'common.nights': 'nuits',
    'common.notProvided': 'Non fourni',
    'common.activity': 'Activité',
    'common.package': 'Forfait',
    'common.accommodation': 'Hébergement',
    'equipment.fishingRod': 'canne à pêche',
    'equipment.bait': 'appâts',
    'equipment.lifeJacket': 'gilet de sauvetage',
    'equipment.kayak': 'kayak',
    'equipment.paddle': 'pagaie',
    'equipment.hikingBoots': 'bottes de randonnée',
    'equipment.binoculars': 'jumelles',
    'equipment.huntingWeapon': 'arme de chasse',
    'equipment.camouflageClothes': 'vêtements de camouflage',
    'equipment.skis': 'skis',
    'equipment.poles': 'bâtons',
    'equipment.boots': 'bottes',
    'equipment.iceDrill': 'perceuse à glace',
    'equipment.shelter': 'abri',
  },
  en: {
    'common.language': 'Language',
    'common.guest': 'Guest',
    'common.client': 'Client',
    'common.manager': 'Manager',
    'common.staff': 'Staff',
    'common.sidebarDemo': 'Demo',
    'common.reception': 'Reception',
    'common.staffTasks': 'My tasks',
    'common.promoCodes': 'Promo codes',
    'common.loyaltyProgram': 'Loyalty program',
    'common.languageName.fr': 'French',
    'common.languageName.en': 'English',
    'common.languageName.zh': 'Chinese',
    'common.login': 'Login',
    'common.logout': 'Logout',
    'common.backToBookingSite': 'Back to booking site',
    'common.home': 'Home',
    'common.accommodations': 'Accommodations',
    'common.stays': 'Accommodations',
    'common.activities': 'Activities',
    'common.packages': 'Packages',
    'common.reservations': 'Reservations',
    'common.dashboard': 'Dashboard',
    'common.reports': 'Reports',
    'common.crm': 'Client Management',
    'common.marketing': 'Marketing',
    'common.settings': 'Settings',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.available': 'Available',
    'common.unavailable': 'Unavailable',
    'common.price': 'Price',
    'common.notEditable': 'is not editable.',
    'common.perNight': 'per night',
    'common.perPerson': 'per person',
    'common.perNightPerPerson': 'per night per person',
    'common.priceTaxIncludedShort': 'incl. tax',
    'common.maxPersons': 'Maximum {count} persons',
    'common.equipmentIncluded': 'Equipment included',
    'common.persons': 'persons',
    'common.upTo': 'Up to',
    'common.lakefront': 'Lakefront',
    'common.popular': 'Popular',
    'common.capacity': 'Capacity',
    'common.duration': 'Duration',
    'common.equipment': 'Equipment',
    'common.amenities': 'Amenities',
    'common.location': 'Location',
    'common.type': 'Type',
    'common.description': 'Description',
    'common.book': 'Book',
    'common.planYourVisit': 'Plan your visit',
    'common.quickBook': 'Quick Book',
    'common.addToCart': 'Add to Cart',
    'common.cart': 'Cart',
    'common.quickNavigation': 'Quick navigation',
    'common.accountDockSignedInHint': 'Portal or sign out',
    'common.languageDockSelect': 'Choose language',
    'common.dockClickHint':
      'Tip: tap or click an icon to open or close panels (calendar, cart, and more). Hover for details.',
    'common.inCart': 'In Cart',
    'common.clear': 'Clear',
    'common.clearFilters': 'Clear filters',
    'common.removeFromCart': 'Remove from Cart',
    'common.like': 'Like',
    'common.unlike': 'Unlike',
    'common.addToFavorites': 'Add to Favorites',
    'common.removeFromFavorites': 'Remove from Favorites',
    'common.share': 'Share',
    'common.linkCopied': 'Link copied!',
    'common.actions': 'Actions',
    'common.viewDetails': 'View details',
    'common.back': 'Back to Stays',
    'common.goBack': 'Back',
    'common.backToHome': 'Back to Home',
    'common.priceStartsAt': 'Prices start at:',
    'common.bookNow': 'BOOK NOW',
    'common.status': 'Status',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.remove': 'Remove',
    'common.name': 'Name',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.add': 'Add',
    'navigation.home': 'Home',
    'navigation.stays': 'Stays',
    'navigation.activities': 'Activities',
    'navigation.forfaits': 'Packages',
    'navigation.gallery': 'Gallery',
    'stays.backToList': 'Back to stays',
    'common.lac': 'Lake',
    'common.forêt': 'Forest',
    'common.mixte': 'Mixed',
    'common.photo': 'Photo',
    'stays.availability': 'Availability',
    'stays.backToList': 'Back to stays',
    'stays.aboutRoom': 'Details Here About Our Room',
    'stays.whatsIncluded': 'What\'s Included in This Room Package?',
    'stays.roomAmenities': 'Room Amenities',
    'stays.relatedStays': 'Browse Similar Escapes',
    'activities.backToList': 'Back to activities',
    'activities.aboutActivity': 'About this activity',
    'activities.whatsIncluded': "What's included",
    'activities.included': 'Included',
    'activities.notIncluded': 'Not included',
    'activities.optionalPaid': 'Optional (paid)',
    'activities.quickFacts': 'Quick facts',
    'activities.relatedActivities': 'More activities',
    'activities.singleDescription': 'Select a date to book this activity.',
    'forfaits.backToList': 'Back to packages',
    'common.favorite': 'Favorite',
    'common.zone': 'Zone',
    'amenities.wifi': 'Free Wi-Fi',
    'amenities.tv': 'Smart TV',
    'amenities.coffee': 'Coffee Maker',
    'amenities.bath': 'Private Bath',
    'amenities.capacity': 'Capacity',
    'amenities.location': 'Great Location',
    'common.optional': 'Optional',
    'common.confirm': 'Confirm',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.configure': 'Configure',
    'common.preview': 'Preview',
    'common.total': 'Total',
    'common.subtotal': 'Subtotal',
    'common.tax': 'Tax',
    'common.gst': 'GST',
    'common.qst': 'QST',
    'common.taxGstLabel': 'GST (5%)',
    'common.taxQstLabel': 'QST (9.975%)',
    'common.taxLodgingLabel': 'Lodging tax ($3.50/night)',
    'common.checkoutSalesTaxNote':
      'GST and QST each apply to the same taxable amount (subtotal plus lodging tax when applicable). QST is not calculated on GST.',
    'common.grandTotal': 'Grand Total',
    'common.checkout': 'Check-out',
    'common.checkoutAsGuest': 'Check-out as Guest',
    'common.checkoutAsMember': 'Check-out as Member',
    'common.payAsGuest': 'Pay as Guest',
    'common.payAsMember': 'Pay as Member',
    'common.choosePaymentMethod': 'Choose Payment Method',
    'common.selectAll': 'Select all',
    'common.deselectAll': 'Deselect all',
    'common.selected': 'selected',
    'common.item': 'item',
    'common.items': 'items',
    'common.selectedItems': 'Selected Items',
    'common.orderSummary': 'Order Summary',
    'common.completeOrder': 'Complete Order',
    'common.quantity': 'Qty',
    'common.booking': 'Booking',
    'common.bookingDetails': 'Booking Details',
    'common.checkIn': 'Check-in',
    'common.checkOut': 'Check-out',
    'common.guests': 'Guests',
    'common.adults': 'Adults',
    'common.children': 'Children',
    'common.notes': 'Notes',
    'common.specialRequests': 'Special Requests',
    'common.contactInfo': 'Contact Information',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.hello': 'Hello',
    'common.myAccount': 'My Account',
    'common.address': 'Address',
    'common.city': 'City',
    'common.province': 'Province',
    'common.postalCode': 'Postal Code',
    'common.country': 'Country',
    'common.paymentMethod': 'Payment Method',
    'paymentLink.title': 'Pay for your reservation',
    'paymentLink.greeting': 'Hello {name},',
    'paymentLink.accommodation': 'Accommodation',
    'paymentLink.checkIn': 'Check-in',
    'paymentLink.checkOut': 'Check-out',
    'paymentLink.total': 'Total due',
    'paymentLink.invalid': 'Invalid payment link.',
    'paymentLink.unavailableTitle': 'Link unavailable',
    'paymentLink.unavailableBody': 'This link has expired, was already used, or no longer exists.',
    'paymentLink.successTitle': 'Payment received',
    'paymentLink.successBody': 'Thank you — your reservation is confirmed. You will receive a confirmation email.',
    'common.creditCard': 'Credit Card',
    'common.cardNumber': 'Card Number',
    'common.expiryDate': 'Expiry Date',
    'common.cvv': 'CVV',
    'common.cardholderName': 'Cardholder Name',
    'common.billingAddress': 'Billing Address',
    'common.sameAsContact': 'Same as contact address',
    'common.termsAndConditions': 'Terms and Conditions',
    'common.privacyPolicy': 'Privacy Policy',
    'common.refundPolicy': 'Refund Policy',
    'common.bookingPolicy': 'Booking Policy',
    'common.cancellationPolicy': 'Cancellation Policy',
    'common.weather': 'Weather',
    'common.sunny': 'Sunny',
    'common.cloudy': 'Cloudy',
    'common.rainy': 'Rainy',
    'common.snowy': 'Snowy',
    'common.mph': 'mph',
    'common.menu': 'Menu',
    'common.close': 'Close',
    'common.question': 'Question',
    'common.sendMessage': 'Send message',
    'common.allRightsReserved': 'All rights reserved.',
    'common.temperature': 'Temperature',
    'common.conditions': 'Conditions',
    'common.forecast': 'Forecast',
    'common.today': 'Today',
    'common.tomorrow': 'Tomorrow',
    'common.thisWeek': 'This week',
    'common.previous': 'Previous',
    'common.next': 'Next',
    'common.nextWeek': 'Next week',
    'common.thisMonth': 'This month',
    'common.nextMonth': 'Next month',
    'common.thisYear': 'This year',
    'common.nextYear': 'Next year',
    'common.january': 'January',
    'common.february': 'February',
    'common.march': 'March',
    'common.april': 'April',
    'common.may': 'May',
    'common.june': 'June',
    'common.july': 'July',
    'common.august': 'August',
    'common.september': 'September',
    'common.october': 'October',
    'common.november': 'November',
    'common.december': 'December',
    'common.monday': 'Monday',
    'common.tuesday': 'Tuesday',
    'common.wednesday': 'Wednesday',
    'common.thursday': 'Thursday',
    'common.friday': 'Friday',
    'common.saturday': 'Saturday',
    'common.sunday': 'Sunday',
    'common.morning': 'Morning',
    'common.afternoon': 'Afternoon',
    'common.evening': 'Evening',
    'common.night': 'Night',
    'common.weekend': 'Weekend',
    'common.weekday': 'Weekday',
    'common.holiday': 'Holiday',
    'common.season': 'Season',
    'common.spring': 'Spring',
    'common.summer': 'Summer',
    'common.autumn': 'Autumn',
    'common.winter': 'Winter',
    'common.allSeasons': 'All year',
    'common.catalogUpdatingTitle': "We're updating this section",
    'common.catalogUpdatingBody':
      'New offers are on the way — please check back soon. Thank you for your patience.',
    'common.lake': 'Lakefront',
    'common.forest': 'In forest',
    'common.mixed': 'Mixed',
    'common.cabin': 'Cabin',
    'common.yurt': 'Yurt',
    'common.unit': 'Unit',
    'common.fishing': 'Fishing',
    'common.hunting': 'Hunting',
    'common.kayaking': 'Kayaking',
    'common.hiking': 'Hiking',
    'common.snowshoeing': 'Snowshoeing',
    'common.skiing': 'Skiing',
    'common.snowmobiling': 'Snowmobiling',
    'common.iceFishing': 'Ice Fishing',
    'common.wildlife': 'Wildlife',
    'common.birdWatching': 'Bird Watching',
    'common.photography': 'Photography',
    'common.nature': 'Nature',
    'common.adventure': 'Adventure',
    'common.relaxation': 'Relaxation',
    'common.family': 'Family',
    'common.couples': 'Couples',
    'common.groups': 'Groups',
    'common.solo': 'Solo',
    'common.business': 'Business',
    'common.leisure': 'Leisure',
    'common.luxury': 'Luxury',
    'common.budget': 'Budget',
    'common.midRange': 'Mid-range',
    'common.premium': 'Premium',
    'common.basic': 'Basic',
    'common.standard': 'Standard',
    'common.deluxe': 'Deluxe',
    'common.suite': 'Suite',
    'common.studio': 'Studio',
    'common.oneBedroom': 'One bedroom',
    'common.twoBedroom': 'Two bedrooms',
    'common.threeBedroom': 'Three bedrooms',
    'common.fourBedroom': 'Four bedrooms',
    'common.penthouse': 'Penthouse',
    'common.villa': 'Villa',
    'common.chalet': 'Chalet',
    'common.cottage': 'Cottage',
    'common.lodge': 'Lodge',
    'common.resort': 'Resort',
    'common.hotel': 'Hotel',
    'common.motel': 'Motel',
    'common.hostel': 'Hostel',
    'common.bedAndBreakfast': 'Bed & Breakfast',
    'common.airbnb': 'Airbnb',
    'common.vrbo': 'VRBO',
    'common.expedia': 'Expedia',
    'common.tripadvisor': 'TripAdvisor',
    'common.calendar': 'Calendar',
    'common.serviceType': 'Service Type',
    'common.all': 'All',
    'common.selectService': 'Select a service',
    'common.hide': 'Hide',
    'common.show': 'Show',
    'common.list': 'List',
    'common.tickets': 'Tickets',
    'common.grid': 'Grid',
    'common.monthly': 'Monthly',
    'common.weekly': 'Weekly',
    'common.legend': 'Legend',
    'common.availableOn': 'Available on',
    'common.viewCalendar': 'View Calendar',
    'common.hours': 'hours',
    'common.nights': 'nights',
    'common.notProvided': 'Not provided',
    'common.activity': 'Activity',
    'common.package': 'Package',
    'common.accommodation': 'Accommodation',
    'equipment.fishingRod': 'fishing rod',
    'equipment.bait': 'bait',
    'equipment.lifeJacket': 'life jacket',
    'equipment.kayak': 'kayak',
    'equipment.paddle': 'paddle',
    'equipment.hikingBoots': 'hiking boots',
    'equipment.binoculars': 'binoculars',
    'equipment.huntingWeapon': 'hunting weapon',
    'equipment.camouflageClothes': 'camouflage clothes',
    'equipment.skis': 'skis',
    'equipment.poles': 'poles',
    'equipment.boots': 'boots',
    'equipment.iceDrill': 'ice drill',
    'equipment.shelter': 'shelter',
  },
  zh: {
    'common.language': '语言',
    'common.languageDockCycle': '点击切换（FR · EN · 中文）',
    'common.languageDockSelect': '选择语言',
    'common.guest': '访客',
    'common.client': '客户',
    'common.manager': '管理员',
    'common.staff': '员工',
    'common.sidebarDemo': '演示',
    'common.reception': '前台',
    'common.staffTasks': '我的任务',
    'common.promoCodes': '促销代码',
    'common.loyaltyProgram': '忠诚度计划',
    'common.languageName.fr': '法语',
    'common.languageName.en': '英语',
    'common.languageName.zh': '中文',
    'common.login': '登录',
    'common.logout': '登出',
    'common.backToBookingSite': '返回预订网站',
    'common.home': '首页',
    'common.accommodations': '住宿',
    'common.stays': '住宿',
    'common.activities': '活动',
    'common.packages': '套餐',
    'common.reservations': '预订',
    'common.dashboard': '仪表板',
    'common.reports': '报告',
    'common.crm': '客户管理',
    'common.marketing': '营销',
    'common.settings': '设置',
    'common.scrollUp': '向上 / 上一区块',
    'common.scrollDown': '向下 / 下一区块',
    'common.calendarAssistantToggle': '打开或关闭助手',
    'common.cartToggle': '打开或关闭购物车',
    'common.search': '搜索',
    'common.filter': '筛选',
    'common.available': '可用',
    'common.unavailable': '不可用',
    'common.price': '价格',
    'common.notEditable': '不可修改。',
    'common.perNight': '每晚',
    'common.perPerson': '每人',
    'common.perNightPerPerson': '每晚每人',
    'common.priceTaxIncludedShort': '含税',
    'common.maxPersons': '最多{count}人',
    'common.equipmentIncluded': '包含设备',
    'common.persons': '人',
    'common.upTo': '最多',
    'common.lakefront': '湖畔',
    'common.popular': '热门',
    'common.capacity': '容量',
    'common.duration': '时长',
    'common.equipment': '设备',
    'common.amenities': '设施',
    'common.location': '位置',
    'common.type': '类型',
    'common.description': '描述',
    'common.book': '预订',
    'common.planYourVisit': '规划您的行程',
    'common.quickBook': '快速预订',
    'common.addToCart': '添加到购物车',
    'common.cart': '购物车',
    'common.accountDockSignedInHint': '客户端或退出登录',
    'common.quickNavigation': '快速导航',
    'common.dockClickHint': '提示：点击图标可打开或关闭面板（日历、购物车等）。悬停可查看说明。',
    'common.inCart': '已在购物车',
    'common.clear': '清除',
    'common.clearFilters': '清除筛选',
    'common.removeFromCart': '从购物车移除',
    'common.like': '喜欢',
    'common.unlike': '取消喜欢',
    'common.addToFavorites': '添加到收藏',
    'common.removeFromFavorites': '从收藏中移除',
    'common.share': '分享',
    'common.linkCopied': '链接已复制！',
    'common.actions': '操作',
    'common.viewDetails': '查看详情',
    'common.back': '返回住宿列表',
    'common.goBack': '返回',
    'common.backToHome': '返回首页',
    'common.priceStartsAt': '价格起：',
    'common.bookNow': '立即预订',
    'common.status': '状态',
    'common.edit': '编辑',
    'common.delete': '删除',
    'common.remove': '移除',
    'common.name': '名称',
    'common.save': '保存',
    'common.cancel': '取消',
    'common.add': '添加',
    'navigation.home': '首页',
    'navigation.stays': '住宿',
    'navigation.activities': '活动',
    'navigation.forfaits': '套餐',
    'navigation.gallery': '相册',
    'stays.backToList': '返回住宿列表',
    'common.lac': '湖边',
    'common.forêt': '森林',
    'common.mixte': '混合',
    'common.photo': '照片',
    'stays.availability': '可用性',
    'stays.backToList': '返回住宿列表',
    'stays.aboutRoom': '房间详情介绍',
    'stays.whatsIncluded': '套餐包含内容',
    'stays.roomAmenities': '房间设施',
    'stays.relatedStays': '浏览类似住宿',
    'activities.backToList': '返回活动列表',
    'activities.aboutActivity': '关于此活动',
    'activities.whatsIncluded': '包含内容',
    'activities.included': '已包含',
    'activities.notIncluded': '不包含',
    'activities.optionalPaid': '可选（付费）',
    'activities.quickFacts': '要点',
    'activities.relatedActivities': '更多活动',
    'activities.singleDescription': '选择日期以预订此活动。',
    'forfaits.backToList': '返回套餐列表',
    'common.favorite': '收藏',
    'common.zone': '区域',
    'amenities.wifi': '免费Wi-Fi',
    'amenities.tv': '智能电视',
    'amenities.coffee': '咖啡机',
    'amenities.bath': '独立浴室',
    'amenities.capacity': '容量',
    'amenities.location': '优越位置',
    'common.optional': '可选',
    'common.confirm': '确认',
    'common.yes': '是',
    'common.no': '否',
    'common.configure': '配置',
    'common.preview': '预览',
    'common.total': '总计',
    'common.subtotal': '小计',
    'common.tax': '税费',
    'common.gst': 'GST',
    'common.qst': 'QST',
    'common.taxGstLabel': 'GST（5%）',
    'common.taxQstLabel': 'QST（9.975%）',
    'common.taxLodgingLabel': '住宿税（3.50 加元/晚）',
    'common.checkoutSalesTaxNote': 'GST 与 QST 各自以同一应税金额计征（小计加住宿税，如适用）。QST 不计入 GST。',
    'common.grandTotal': '总计',
    'common.checkout': '结账',
    'common.checkoutAsGuest': '以访客身份结账',
    'common.checkoutAsMember': '以会员身份结账',
    'common.selectedItems': '已选项目',
    'common.orderSummary': '订单摘要',
    'common.completeOrder': '完成订单',
    'common.payAsGuest': '以访客身份支付',
    'common.payAsMember': '以会员身份支付',
    'common.choosePaymentMethod': '选择支付方式',
    'common.selectAll': '全选',
    'common.deselectAll': '取消全选',
    'common.select': '选择',
    'common.deselect': '取消选择',
    'common.selected': '已选择',
    'common.item': '项目',
    'common.items': '项目',
    'common.quantity': '数量',
    'common.booking': '预订',
    'common.bookingDetails': '预订详情',
    'common.checkIn': '入住',
    'common.checkOut': '退房',
    'common.guests': '客人',
    'common.adults': '成人',
    'common.children': '儿童',
    'common.notes': '备注',
    'common.specialRequests': '特殊要求',
    'common.contactInfo': '联系信息',
    'common.email': '邮箱',
    'common.phone': '电话',
    'common.hello': '你好',
    'common.clientPortal': '客户空间',
    'common.myAccount': '我的账户',
    'common.address': '地址',
    'common.city': '城市',
    'common.province': '省份',
    'common.postalCode': '邮政编码',
    'common.country': '国家',
    'common.paymentMethod': '付款方式',
    'paymentLink.title': '支付您的预订',
    'paymentLink.greeting': '您好 {name}，',
    'paymentLink.accommodation': '住宿',
    'paymentLink.checkIn': '入住',
    'paymentLink.checkOut': '退房',
    'paymentLink.total': '应付总额',
    'paymentLink.invalid': '付款链接无效。',
    'paymentLink.unavailableTitle': '链接不可用',
    'paymentLink.unavailableBody': '此链接已过期、已使用或不存在。',
    'paymentLink.successTitle': '付款成功',
    'paymentLink.successBody': '谢谢 — 您的预订已确认。您将收到确认邮件。',
    'common.creditCard': '信用卡',
    'common.cardNumber': '卡号',
    'common.expiryDate': '有效期',
    'common.cvv': 'CVV',
    'common.cardholderName': '持卡人姓名',
    'common.billingAddress': '账单地址',
    'common.sameAsContact': '与联系地址相同',
    'common.termsAndConditions': '条款和条件',
    'common.privacyPolicy': '隐私政策',
    'common.refundPolicy': '退款政策',
    'common.bookingPolicy': '预订政策',
    'common.cancellationPolicy': '取消政策',
    'common.weather': '天气',
    'common.sunny': '晴',
    'common.cloudy': '多云',
    'common.rainy': '雨',
    'common.snowy': '雪',
    'common.mph': '英里/小时',
    'common.menu': '菜单',
    'common.close': '关闭',
    'common.question': '问题',
    'common.sendMessage': '发送消息',
    'common.allRightsReserved': '版权所有。',
    'common.temperature': '温度',
    'common.conditions': '条件',
    'common.forecast': '预报',
    'common.today': '今天',
    'common.tomorrow': '明天',
    'common.thisWeek': '本周',
    'common.previous': '上一个',
    'common.next': '下一个',
    'common.nextWeek': '下周',
    'common.thisMonth': '本月',
    'common.nextMonth': '下月',
    'common.thisYear': '今年',
    'common.nextYear': '明年',
    'common.january': '一月',
    'common.february': '二月',
    'common.march': '三月',
    'common.april': '四月',
    'common.may': '五月',
    'common.june': '六月',
    'common.july': '七月',
    'common.august': '八月',
    'common.september': '九月',
    'common.october': '十月',
    'common.november': '十一月',
    'common.december': '十二月',
    'common.monday': '星期一',
    'common.tuesday': '星期二',
    'common.wednesday': '星期三',
    'common.thursday': '星期四',
    'common.friday': '星期五',
    'common.saturday': '星期六',
    'common.sunday': '星期日',
    'common.morning': '早上',
    'common.afternoon': '下午',
    'common.evening': '晚上',
    'common.night': '夜间',
    'common.weekend': '周末',
    'common.weekday': '工作日',
    'common.holiday': '假日',
    'common.season': '季节',
    'common.spring': '春天',
    'common.summer': '夏天',
    'common.autumn': '秋天',
    'common.winter': '冬天',
    'common.allSeasons': '全年',
    'common.catalogUpdatingTitle': '内容更新中',
    'common.catalogUpdatingBody': '我们正在完善此板块，新内容即将上线，请稍后再来查看。感谢您的耐心。',
    'common.lake': '湖畔',
    'common.forest': '森林',
    'common.mixed': '混合',
    'common.cabin': '小屋',
    'common.yurt': '蒙古包',
    'common.unit': '单位',
    'common.fishing': '钓鱼',
    'common.hunting': '狩猎',
    'common.kayaking': '皮划艇',
    'common.hiking': '徒步',
    'common.snowshoeing': '雪鞋',
    'common.skiing': '滑雪',
    'common.snowmobiling': '雪地摩托',
    'common.iceFishing': '冰钓',
    'common.wildlife': '野生动物',
    'common.birdWatching': '观鸟',
    'common.photography': '摄影',
    'common.nature': '自然',
    'common.adventure': '冒险',
    'common.relaxation': '放松',
    'common.family': '家庭',
    'common.couples': '情侣',
    'common.groups': '团体',
    'common.solo': '独自',
    'common.business': '商务',
    'common.leisure': '休闲',
    'common.luxury': '豪华',
    'common.budget': '经济',
    'common.midRange': '中等',
    'common.premium': '高级',
    'common.basic': '基础',
    'common.standard': '标准',
    'common.deluxe': '豪华',
    'common.suite': '套房',
    'common.studio': '单间',
    'common.oneBedroom': '一居室',
    'common.twoBedroom': '两居室',
    'common.threeBedroom': '三居室',
    'common.fourBedroom': '四居室',
    'common.penthouse': '顶层公寓',
    'common.villa': '别墅',
    'common.chalet': '小屋',
    'common.cottage': '小屋',
    'common.lodge': '旅馆',
    'common.resort': '度假村',
    'common.hotel': '酒店',
    'common.motel': '汽车旅馆',
    'common.hostel': '青年旅舍',
    'common.bedAndBreakfast': '民宿',
    'common.airbnb': 'Airbnb',
    'common.vrbo': 'VRBO',
    'common.expedia': 'Expedia',
    'common.tripadvisor': 'TripAdvisor',
    'common.calendar': '日历',
    'common.serviceType': '服务类型',
    'common.all': '全部',
    'common.selectService': '选择服务',
    'common.hide': '隐藏',
    'common.show': '显示',
    'common.list': '列表',
    'common.tickets': '票务',
    'common.grid': '网格',
    'common.monthly': '每月',
    'common.weekly': '每周',
    'common.legend': '图例',
    'common.availableOn': '可用日期',
    'common.viewCalendar': '查看日历',
    'common.hours': '小时',
    'common.nights': '晚',
    'common.notProvided': '未提供',
    'common.activity': '活动',
    'common.package': '套餐',
    'common.accommodation': '住宿',
    'equipment.fishingRod': '钓鱼竿',
    'equipment.bait': '鱼饵',
    'equipment.lifeJacket': '救生衣',
    'equipment.kayak': '皮划艇',
    'equipment.paddle': '桨',
    'equipment.hikingBoots': '徒步靴',
    'equipment.binoculars': '双筒望远镜',
    'equipment.huntingWeapon': '狩猎武器',
    'equipment.camouflageClothes': '迷彩服',
    'equipment.skis': '滑雪板',
    'equipment.poles': '滑雪杖',
    'equipment.boots': '靴子',
    'equipment.iceDrill': '冰钻',
    'equipment.shelter': '庇护所',
  },
};

